import { Box, Typography } from "@mui/material";
import { CommonStyle } from "Components";
import CstmBtn from "Components/CstmBtn";
import {
  ScreenInitialStateType,
  UserInitialStateType
} from "DataTypes/Redux";
import { FC, Fragment, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { startLoading } from "Redux/Screen/Action";
import { HeadDropBoxPropType, HeaderBoxType } from "DataTypes/Common";
import { Logout } from "Utils/common";
import { ModalLayout } from "Layouts";

const DropBox: FC<HeadDropBoxPropType> = (props) => {
  const {
    dataArr,
    width,
    position,
    changeDropState,
    onClick,
  } = props;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { rightHead }: ScreenInitialStateType =
    useSelector((state: any) => state?.screen);
  const { myInfo }: UserInitialStateType = useSelector(
    (state: any) => state?.user
  );
  const [openDrop, setOpenDrop] = useState(false);
  const [openModal, setOpenModal] = useState(false);

  useEffect(() => {
    setOpenDrop(changeDropState);
  }, [changeDropState]);

  const handleBtnClick: () => void = () => {
    if (rightHead.timerStatus == 1) {
      dispatch(
        startLoading({
          loading: true,
          loadtext: "Logging Out...",
        })
      );
      setOpenDrop(false);
      Logout(myInfo.id);
    } else setOpenModal(true);
  };

  const handleClick: (el: HeaderBoxType) => void = (el) => {
    setOpenDrop(false);
    onClick();
    navigate(el.path);
  };

  return (
    <Fragment>
      <ModalLayout
        modwidth="30%"
        heading={"Warning"}
        content={
          <Box textAlign={"center"}>
            <Typography mb={1}>
              {"Please click on Home or Patient's Name"}
              {" before logging out to save the time spent."}
            </Typography>
          </Box>
        }
        open={openModal}
        onClose={() => setOpenModal(false)}
        buttonArr={[
          { id: "Ok", label: "Ok", clickHandler: () => setOpenModal(false) }
        ]}
      />
      {openDrop && (
        <Box
          sx={{
            ...CommonStyle.sxWhiteBox,
            ...sxDropBox,
            width,
            ...(position == "center"
              ? sxCenter
              : position == "left"
                ? sxLeft
                : sxRight),
          }}
        >
          <Box>
            {dataArr.map((el) => {
              return (
                <Fragment key={el.id}>
                  {el.type == "text" ? (
                    <Typography
                      variant="subtitle1"
                      onClick={() => handleClick(el)}
                    >
                      {el.label}
                    </Typography>
                  ) : (
                    <CstmBtn
                      label={el.label}
                      onClick={handleBtnClick}
                      width="100%"
                    />
                  )}
                </Fragment>
              );
            })}
          </Box>
        </Box>
      )}
    </Fragment>
  );
};
export default DropBox;

const sxDropBox = {
  position: "absolute",
  top: "100%",
  zIndex: 999,
  transition: "0.5s",
  "& >div": {
    p: 1,
    "& >h6": {
      cursor: "pointer",
      p: 0.5,
      borderRadius: 1.25,
      borderBottom: "1px solid",
      borderColor: "custom.main",
    },
    "& >h6:hover": {
      backgroundColor: "custom.light",
    },
  },
};

const sxRight = {
  right: 0,
  "&:before": {
    content: "''",
    width: 0,
    height: 0,
    borderLeft: "10px solid transparent",
    borderRight: "10px solid transparent",
    borderBottom: "10px solid #ee7404",
    transform: "rotate(0deg)",
    backgroundColor: "transparent",
    top: "-10px",
    right: "2px",
    position: "absolute",
  },
};

const sxLeft = {
  left: 0,
  "&:before": {
    content: "''",
    width: 0,
    height: 0,
    borderLeft: "10px solid transparent",
    borderRight: "10px solid transparent",
    borderBottom: "10px solid #ee7404",
    transform: "rotate(0deg)",
    backgroundColor: "transparent",
    top: "-10px",
    left: "12px",
    position: "absolute",
  },
};

const sxCenter = {
  right: "-100%",
  "&:before": {
    content: "''",
    width: 0,
    height: 0,
    borderLeft: "10px solid transparent",
    borderRight: "10px solid transparent",
    borderBottom: "10px solid #ee7404",
    transform: "rotate(0deg)",
    backgroundColor: "transparent",
    top: "-10px",
    right: "0px",
    left: "0px",
    margin: "0 auto",
    position: "absolute",
  },
};
